import React from 'react';
import './_resume.scss';

const ResumeSummary = () => (
  <section className="resume--section">
    <h1 className="resume--section-title">Summary</h1>
    <p>
      I am a software developer with experience serving both the private and public sectors. I am
      passionate about technology and crafting simple solutions to complex challenges. I believe in
      writing code that is clean, clear and deliberate.
    </p>
  </section>
);

export default ResumeSummary;



// WEBPACK FOOTER //
// ./src/pages/resume/_Summary.js